module.exports = __webpack_public_path__ + "img/product05.e5bbb260.jpg";